// Open modals carry data-turbo-permanent (see setup/modal_morph_persistence)
// so a turbo_stream.refresh morph landing underneath cannot kill them. The
// one modal that SHOULD close on the following morph is the one whose own
// form just submitted successfully — these functions track that mark on the
// modal element itself, shared by base_modal.js and remote_modal_controller
// (two controller instances on the same element).
//
// The mark expires: a successful intra-modal submit that never triggers a
// page render (multi-step flows inside a modal) must not let a much later
// background refresh close the modal. The window just needs to outlive a
// slow save response plus the refresh's page fetch.
const SUBMIT_MARK_MAX_AGE_MS = 10_000

export function markSubmitted(modalElement) {
  modalElement._submittedAt = Date.now()
}

export function clearSubmitMark(modalElement) {
  delete modalElement._submittedAt
}

export function justSubmitted(modalElement) {
  if (!modalElement._submittedAt) { return false }

  return Date.now() - modalElement._submittedAt <= SUBMIT_MARK_MAX_AGE_MS
}

// A Turbo render may force-close an open modal when:
// - it is a full-page (non-morph) render: the page underneath is being
//   replaced wholesale, and leaving the modal permanent would transplant it
//   onto the next page; or
// - it is a morph and this modal's own form just submitted — the refresh
//   the save triggered is the modal's cue to close.
// Any other morph is background noise the open modal must survive.
export function shouldForceCloseOnRender(modalElement, renderEvent) {
  if (renderEvent.detail?.renderMethod !== "morph") { return true }

  return justSubmitted(modalElement)
}
